// extracted by mini-css-extract-plugin
module.exports = {"logoContaniner":"comparison-table_logoContaniner___r7Le"};